import React, {useEffect} from 'react';
import wrap from 'wraptile';
import {CircularProgress, InputLabel, FormControl, Select} from '@material-ui/core';
import {NoteType, OnSelectChangeEvent} from '@pluto/@types';
import {QCReportsReasonsState, QCReportsReasonsItem} from '../QCReportsReasonsTypes';

export interface QCReportsReasonsContainerProps {
    qcReportsReasons: QCReportsReasonsState;
    selectReasonPlaceholder: string;
    setQcReportsReasons: (type: NoteType) => void;
    resetQcReportReasons: () => void;
    value: number | string;
    onChange: (event: OnSelectChangeEvent) => void;
    noteType: NoteType;
    disabled?: boolean;
}

export const mapReportsReasonsToOptions = ({id, label}: QCReportsReasonsItem) => (
    <option key={label} value={id}>
        {label}
    </option>
);

export const getOptions = (reasons: QCReportsReasonsItem[]) => {
    if (!reasons) {
        return null;
    }

    return reasons?.map(mapReportsReasonsToOptions);
};

export const handleFetchReportsReasons = wrap(
    (
        setQcReportsReasons: (type: NoteType) => void,
        resetQcReportReasons: () => void,
        noteType: NoteType,
        isLoading: boolean,
        data: QCReportsReasonsItem[]
    ) => {
        if (isLoading || data[0]?.type !== noteType) {
            setQcReportsReasons(noteType);

            return resetQcReportReasons;
        }
    }
);

const QCReportsReasonsContainer = (props: QCReportsReasonsContainerProps) => {
    const {
        qcReportsReasons,
        setQcReportsReasons,
        resetQcReportReasons,
        selectReasonPlaceholder,
        value,
        onChange,
        noteType,
        disabled,
    } = props;
    const {data, isLoading} = qcReportsReasons;
    const options = getOptions(data);
    const fetchReportsReasons = handleFetchReportsReasons(
        setQcReportsReasons,
        resetQcReportReasons,
        noteType,
        isLoading,
        data
    );

    useEffect(fetchReportsReasons, []);

    if (isLoading) {
        return <CircularProgress />;
    }
    return (
        <FormControl>
            <InputLabel>{selectReasonPlaceholder}</InputLabel>
            <Select native value={value} onChange={onChange} disabled={disabled}>
                <option value="" disabled hidden />
                {options}
            </Select>
        </FormControl>
    );
};

export default QCReportsReasonsContainer;
